
	import { defineComponent, provide } from "vue";
	import { UserStatus } from "@/infraestructure/auth/auth_facade";
	import { PatientRepository } from "@/infraestructure/patient/PatientRepository";
	import useNotification from "@/store/NotificationState";
	import useAuth from "@/store/AuthState";
	import { combineLatest } from "rxjs";
	import { pprint } from "@/helpers/pprint";
	import { useRouter } from "vue-router";
	import { DoctorRepository } from "./infraestructure/doctor/DoctorRepository";
	import FullscreenLoadingIndicator from "@/components/FullscreenLoadingIndicator.vue";
import useApp from "./store/AppState";

	export default defineComponent({
		components: {
			FullscreenLoadingIndicator,
		},
		setup() {
			const { init, authStatus, statusListener, updateFCMToken } = useAuth();
			init();
			provide(PatientRepository.key, new PatientRepository());
			provide(DoctorRepository.key, new DoctorRepository());

			const router = useRouter();
			router.beforeEach((to, from, next) => {
				if (to.name !== "Login" && authStatus.value === UserStatus.SignedOut)
					next({ name: "Login" });
				else if (to.name === "Login" && authStatus.value === UserStatus.SignedIn)
					next({ name: "dashboard" });
				else next();
			});

			const { showUpdateSWBanner, updateServiceWorkerConfirmed } = useApp();
			const {
				messages,
				deleteSnackbarAt,
				// listenTokenRefresh,
				fcmTokenListener,
				listenOnMessage,
				SnackbarMessageLevel,
			} = useNotification();
			listenOnMessage();

			combineLatest(statusListener, fcmTokenListener).subscribe((r) => {
				const isSignedIn = authStatus.value === UserStatus.SignedIn;
				const fcmToken = r[1];
				pprint("-- combined listener --", r);
				if (isSignedIn && fcmToken !== null) {
					pprint("-- update FCM triggered --");
					updateFCMToken(fcmToken);
				}
			});
			// listenTokenRefresh();

			return {
				authStatus,
				UserStatus,
				messages,
				deleteSnackbarAt,
				Level: SnackbarMessageLevel,
				showUpdateSWBanner,
				updateServiceWorkerConfirmed,
			};
		},
	});
